import { render, staticRenderFns } from "./t-list-link-primary.vue?vue&type=template&id=1c2cbfe2&"
import script from "./t-list-link-primary.vue?vue&type=script&lang=js&"
export * from "./t-list-link-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports